// extracted by mini-css-extract-plugin
export default {"component":"qyK5J"};